import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  TextField,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const ChangeFtpPasswordDialog = ({
  open,
  onClose,
  apiKey,
  onSave,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);

  // ------------------------
  // Submit Handler
  // ------------------------
  const handleSubmit = async () => {
    if (!password || !confirmPassword) return;

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      await onSave({
        apiKey,
        password,
      });

      setPassword("");
      setConfirmPassword("");
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 2,
          fontFamily: "Figtree",
        },
      }}
    >
      <DialogContent>
        {/* HEADER */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography fontWeight={600} fontSize={18}>
            Change Password
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* NEW PASSWORD */}
        <Box mb={2}>
          <Typography fontSize={13} mb={0.5}>
            Create New Password
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter New Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
              sx: {
                borderRadius: "10px",
                background: "var(--app-surface-2)",
              },
            }}
          />
        </Box>

        {/* CONFIRM PASSWORD */}
        <Box mb={3}>
          <Typography fontSize={13} mb={0.5}>
            Confirm New Password
          </Typography>

          <TextField
            fullWidth
            placeholder="Confirm New Password"
            type={showConfirm ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowConfirm((prev) => !prev)}
                  edge="end"
                >
                  {showConfirm ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
              sx: {
                borderRadius: "10px",
                background: "var(--app-surface-2)",
              },
            }}
          />
        </Box>

        {/* BUTTON */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            height: "48px",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            background:
              "linear-gradient(90deg, #6C63FF 0%, #5A54E8 100%)",
            boxShadow: "none",
            "&:hover": {
              background:
                "linear-gradient(90deg, #5A54E8 0%, #4F46E5 100%)",
            },
          }}
        >
          {loading ? "Saving..." : "Save Password"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeFtpPasswordDialog;